import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { galleryImages } from "../../mock";

const CtaBand = () => {
  return (
    <section className="section bg-cream-100">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-navy-700 to-navy-800 px-6 py-16 md:px-16 md:py-20">
          <div className="absolute -right-20 -top-20 w-80 h-80 rounded-full bg-coral-300/30 blur-3xl" />
          <div className="absolute -left-10 bottom-0 w-72 h-72 rounded-full bg-coral-200/20 blur-3xl" />

          <div className="relative grid md:grid-cols-2 gap-10 items-center">
            <div>
              <p className="tracking-widest text-coral-300 text-xs font-semibold uppercase">Ready when you are</p>
              <h2 className="font-serif text-cream-100 text-4xl md:text-5xl lg:text-[56px] mt-4 leading-[1.05]">
                How many <span className="italic text-coral-300">memories</span> will your guests share?
              </h2>
              <p className="text-cream-100/75 mt-5 text-lg max-w-lg">
                There&apos;s magic in life&apos;s unforgettable moments. Don&apos;t miss a single one.
              </p>
              <div className="mt-7 flex flex-wrap gap-4">
                <Link to="/pricing" className="inline-flex items-center gap-2 bg-coral-300 text-white px-7 py-3.5 rounded-full font-semibold hover:bg-coral-400 transition-colors">
                  See Pricing <ArrowRight className="w-4 h-4" />
                </Link>
                <Link to="/how-it-works" className="inline-flex items-center gap-2 border border-cream-100/30 text-cream-100 px-7 py-3.5 rounded-full font-semibold hover:bg-white/5 transition-colors">
                  How It Works
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-3">
              {galleryImages.slice(0, 6).map((g, i) => (
                <div key={g} className={`rounded-xl overflow-hidden ${i % 2 ? "aspect-[3/4] mt-6" : "aspect-square"}`}>
                  <img src={g} alt="" className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaBand;
